import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";
import {captureDomainSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {vehiclesService} from "../services";

export default function useCreateVehicle() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: vehiclesService.createVehicle,
    onSuccess: async () => {
      // invalidateQueries (not refetchQueries): list unmounts on navigate to detail;
      // mark stale so the list refetches on remount even within global staleTime.
      await queryClient.invalidateQueries({queryKey: ["vehicles"]});
    },
    onError: (error) => {
      captureDomainSubmitError(error, {feature: "vehicles", operation: "vehicle_create"});
      errorHandler(error);
    },
  });
}
